import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MouseEvent, ReactNode } from 'react';

export enum ModalType {
  SHARE_SELECTION,
}

interface IButtonContent {
  label: string;
  onClick: (e: MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  type?: 'primary' | 'secondary';
  shouldStretch?: boolean;
}

export type ModalContent = {
  /** The icon displayed in the title bar */
  titleIcon?: string;
  /** Set to true to use material icons filled */
  titleIconFilled?: boolean;
  /** Title to the left of the title icon */
  title?: ReactNode;
  /** The content that is displayed.
   * If the component is complicated, make a component and pass it in.
   */
  content?: ReactNode;
  onClose?: (e?: MouseEvent<HTMLButtonElement>) => void;
  backgroundColor?: string | undefined;
  displayClose?: boolean;
  canClickOutside?: boolean;
  step?: number;
  steps?: number;
  modalClassName?: string;
  buttons?: IButtonContent[];
  description?: ReactNode;
};

type ModalHandler = {
  modalType: ModalType | null;
  modalContent: ModalContent | null;
};

const initialState: ModalHandler = {
  modalContent: null,
  modalType: null,
};

/**
 * Used to control what modal is currently active
 */
const modalHandlerSlice = createSlice({
  initialState,
  name: 'modal-handler',
  reducers: {
    clearModalContent: (state) => {
      state.modalContent = null;
    },
    setModalContent: (state, action: PayloadAction<ModalContent | null>) => {
      state.modalContent = action.payload;
    },
  },
});

export const { setModalContent, clearModalContent } = modalHandlerSlice.actions;

export default modalHandlerSlice.reducer;
